"use client";
import { FiArrowUpRight } from "react-icons/fi";
import ContactForm from "@/components/Contact/ContactForm";
import ContactInfo from "@/components/Contact/ContactInfo";

import { useLanguageStore } from "@/providers/useLanguageStore";
import ContactAbout from "@/components/Contact/ContactAbout";
import ContactAddress from "@/components/Contact/ContactAddress";

const ContactPage: React.FC = () => {
  const { translations } = useLanguageStore();

  return (
    <section className="py-8 md:py-12 bg-white relative">
      <h2 className=" mx-auto px-4 md:px-16 text-4xl lg:text-4xl font-bold text-red-600 font-archivo mb-8 flex items-center">
        <FiArrowUpRight className="text-red-600 text-4xl mr-2" />
        {translations.contactPageTitle || "Contacto"}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <ContactInfo />
        <ContactForm />
      </div>
      <ContactAbout />
      <ContactAddress />
    </section>
  );
};

export default ContactPage;
